import { render, staticRenderFns } from "./OrderReports.vue?vue&type=template&id=5f325a6f"
import script from "./OrderReports.vue?vue&type=script&lang=js"
export * from "./OrderReports.vue?vue&type=script&lang=js"
import style0 from "./OrderReports.vue?vue&type=style&index=0&id=5f325a6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports